import { locationClient } from './api-grpc';
import {
  GetAllLocationsWithInstallationWorstStateResponse,
  GetLocationListByAddressResponse,
  GetLocationListByERPIdResponse,
  GetLocationListByPageResponse,
  Location,
} from '../gen/proto/api/gateway/v1/location_pb';

export const locationApi = {
  async getListByPage(pageIndex: number, pageSize: number): Promise<GetLocationListByPageResponse> {
    return await locationClient.getLocationListByPage({
      pagination: {
        pageIndex,
        pageSize,
      },
    });
  },

  async getByUuid(uuid: string): Promise<Location> {
    const response = await locationClient.getLocationByUuid({ uuid });
    if (!response.location) {
      throw new Error('No location returned for uuid: ' + uuid);
    }
    return response.location;
  },

  async create(params: {
    name: string;
    address: string;
    cp: string;
    city: string;
    country: string;
    latitude: number;
    longitude: number;
    erpId: string;
    tenantUuid: string;
    adminUuid: string;
    numberOfApartments?: number;
    numberOfFloors?: number;
    numberOfCommercialUnits?: number;
    buildingAreaM2?: number;
    averageAge?: number;
    numberOfPeople?: number;
    roofAreaM2?: number;
    hasRainwaterHarvesting?: boolean;
  }): Promise<Location> {
    const response = await locationClient.createLocation({
      name: params.name,
      address: params.address,
      cp: params.cp,
      city: params.city,
      country: params.country,
      latitude: params.latitude,
      longitude: params.longitude,
      erpId: params.erpId,
      tenantUuid: params.tenantUuid,
      adminUuid: params.adminUuid,
      numberOfApartments: params.numberOfApartments,
      numberOfFloors: params.numberOfFloors,
      numberOfCommercialUnits: params.numberOfCommercialUnits,
      buildingAreaM2: params.buildingAreaM2,
      averageAge: params.averageAge,
      numberOfPeople: params.numberOfPeople,
      roofAreaM2: params.roofAreaM2,
      hasRainwaterHarvesting: params.hasRainwaterHarvesting,
    });
    if (!response.location) {
      throw new Error('No location returned after create');
    }
    return response.location;
  },

  async getListByAddress(
    address: string,
    pageIndex: number,
    pageSize: number,
  ): Promise<GetLocationListByAddressResponse> {
    return await locationClient.getLocationListByAddress({
      address,
      pagination: { pageIndex, pageSize },
    });
  },

  async getListByERPId(erpId: string, pageIndex: number, pageSize: number): Promise<GetLocationListByERPIdResponse> {
    return await locationClient.getLocationListByERPId({
      erpId,
      pagination: { pageIndex, pageSize },
    });
  },

  async delete(uuid: string): Promise<void> {
    await locationClient.deleteLocation({ uuid });
  },

  async update(params: {
    address: string;
    city: string;
    country: string;
    cp: string;
    erp_id: string;
    latitude: number;
    longitude: number;
    name: string;
    uuid: string;
    tenantUuid: string;
    adminUuid: string;
    numberOfApartments?: number;
    numberOfFloors?: number;
    numberOfCommercialUnits?: number;
    buildingAreaM2?: number;
    averageAge?: number;
    numberOfPeople?: number;
    roofAreaM2?: number;
    hasRainwaterHarvesting?: boolean;
  }): Promise<void> {
    await locationClient.updateLocation({
      address: params.address,
      city: params.city,
      country: params.country,
      latitude: params.latitude,
      longitude: params.longitude,
      name: params.name,
      uuid: params.uuid,
      cp: params.cp,
      erpId: params.erp_id,
      tenantUuid: params.tenantUuid,
      adminUuid: params.adminUuid,
      numberOfApartments: params.numberOfApartments,
      numberOfFloors: params.numberOfFloors,
      numberOfCommercialUnits: params.numberOfCommercialUnits,
      buildingAreaM2: params.buildingAreaM2,
      averageAge: params.averageAge,
      numberOfPeople: params.numberOfPeople,
      roofAreaM2: params.roofAreaM2,
      hasRainwaterHarvesting: params.hasRainwaterHarvesting,
    });
  },

  async getAllLocationsWithInstallationWorstState(): Promise<GetAllLocationsWithInstallationWorstStateResponse> {
    const response = await locationClient.getAllLocationsWithInstallationWorstState({});

    if (!response.locations) {
      throw new Error('No locations returned for uuid');
    }
    return response;
  },
};
